import React, { useContext, useEffect, useState } from "react";

import DrawBox from "../../components/DrawBox/DrawBox";
import SearchBar from "../../components/TextInput/SearchBar";

import useAuthClient from "../../hooks/useAuthClient";
import useFetchDraws from "../../hooks/useFetchDraws";
import useFetchResults from "../../hooks/useFetchResults";
import useSetPageTitle from "../../hooks/useSetPageTitle";

import arrow from "../../assets/icons/arrowdown.png";
import "./styles.css";
import UserContext from "../../contexts/UserContext";

function Results() {
  const { currentPromo } = useContext(UserContext);

  useAuthClient(currentPromo);
  useSetPageTitle("Resultados", currentPromo);

  const [dropdown, setDropdown] = useState(false);
  const [searchInfo, setSearchInfo] = useState("");
  const [drawsWeek, setDrawsWeek] = useState([]);
  const [drawsMonth, setDrawsMonth] = useState([]);
  const [drawsFinal, setDrawsFinal] = useState([]);

  const [sorteio, setSorteio] = useState(null);

  const formatDate = (unformattedDate) =>
    unformattedDate.split("-").reverse().join("/");

  useFetchDraws(
    currentPromo?.id,
    setDrawsWeek,
    setDrawsMonth,
    setDrawsFinal,
    setSorteio,
  );
  const resultsDb = useFetchResults(currentPromo?.id, sorteio?.id);
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!searchInfo?.length) {
      setResults(resultsDb);
      return;
    }

    const needle = searchInfo.toLowerCase();
    const includes = (haystack) =>
      String(haystack).toLowerCase().includes(needle);

    setResults(
      resultsDb.filter(
        (item) =>
          includes(item.register) ||
          includes(item.razao_social) ||
          includes(item.voucher) ||
          includes(item.premio.nome),
      ),
    );
  }, [resultsDb, searchInfo]);

  return (
    <div className="container">
      <h1>Ganhadores</h1>
      <p className="results-dropdown-title">Selecione o sorteio</p>
      <div
        className={dropdown ? "results-dropdown-selected" : "results-dropdown"}
        onClick={() => setDropdown(!dropdown)}
      >
        <img
          src={arrow}
          alt="arrow-down"
          className={
            dropdown ? "results-dropdown-arrow-up" : "results-dropdown-arrow"
          }
        />
        {!!sorteio && (
          <p>{`Sorteio ${sorteio.tipo.charAt(0).toUpperCase() + sorteio.tipo.slice(1)} - ${formatDate(sorteio.data)}`}</p>
        )}
        {!sorteio && <p>Selecione um Sorteio</p>}
      </div>
      <div
        className={
          dropdown
            ? "results-dropdown-container-visible"
            : "results-dropdown-container-hidden"
        }
      >
        <div
          className={
            dropdown
              ? "results-dropdown-content-visible"
              : "results-dropdown-content-hidden"
          }
        >
          {!!drawsWeek.length && (
            <>
              {drawsMonth.length + drawsFinal.length > 0 && (
                <p className="results-dropdown-subtitle">
                  Resultados dos Sorteios Semanais
                </p>
              )}
              <div className="results-dropdown-draw-boxes-container">
                {drawsWeek.map((draw) => (
                  <DrawBox
                    key={`Sorteio - ${draw.data}`}
                    name={`Sorteio - ${formatDate(draw.data)}`}
                    startDate={formatDate(draw.inicio)}
                    endDate={formatDate(draw.fim)}
                    selected={draw.selected}
                    disabled={draw.status === "nao_realizado"}
                    onClick={() => {
                      if (draw.status !== "nao_realizado") {
                        setDropdown(false);
                        setSorteio(draw);
                      }
                    }}
                  />
                ))}
              </div>
            </>
          )}
          {!!drawsMonth.length && (
            <>
              {drawsWeek.length + drawsFinal.length > 0 && (
                <p className="results-dropdown-subtitle">
                    Resultados dos Sorteios Mensais
                </p>
              )}
              <div className="results-dropdown-draw-boxes-container">
                {drawsMonth.map((draw) => (
                  <DrawBox
                    key={`Sorteio - ${draw.data}`}
                    name={`Sorteio - ${formatDate(draw.data)}`}
                    startDate={formatDate(draw.inicio)}
                    endDate={formatDate(draw.fim)}
                    selected={draw.selected}
                    disabled={draw.status === "nao_realizado"}
                    onClick={() => {
                      if (!draw.disabled && !draw.selected) {
                        if (draw.status !== "nao_realizado") {
                          setDropdown(false);
                          setSorteio(draw);
                        }
                      }
                    }}
                  />
                ))}
              </div>
            </>
          )}
          {!!drawsFinal.length && (
            <>
              {drawsWeek.length + drawsMonth.length > 0 && (
                <p className="results-dropdown-subtitle">
                  Resultados do Sorteio Final
                </p>
              )}
              <div className="results-dropdown-draw-boxes-container">
                {drawsFinal.map((draw) => (
                  <DrawBox
                    key={`Sorteio - ${draw.data}`}
                    name={`Sorteio - ${formatDate(draw.data)}`}
                    startDate={formatDate(draw.inicio)}
                    endDate={formatDate(draw.fim)}
                    selected={draw.selected}
                    disabled={draw.status === "nao_realizado"}
                    onClick={() => {
                      if (draw.status !== "nao_realizado") {
                        setDropdown(false);
                        setSorteio(draw);
                      }
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
      {!!sorteio && (
        <>
          <p className="results-table-title">{`Sorteio ${sorteio.tipo.charAt(0).toUpperCase() + sorteio.tipo.slice(1)} - ${formatDate(sorteio.data)}`}</p>
          <div className="results-table-search-container">
            <SearchBar
              value={searchInfo}
              setValue={setSearchInfo}
              placeholder="Procure informações"
            />
          </div>
          {!!results.length && (
            <table className="results-table card-table">
              <thead>
                <tr>
                  <th style={{ opacity: "0.3", width: "120px" }}>#</th>
                  <th>Razão social</th>
                  <th>Número da sorte</th>
                  <th>Prêmio</th>
                </tr>
              </thead>
              <tbody>
                {results
                  .filter(
                    (item) =>
                      item.client_id === Number(localStorage.getItem("id")),
                  )
                  .map((item, index) => (
                    <tr key={index - 100} className="table-you-win-row">
                      <td style={{ opacity: "0.3" }}>!</td>
                      <td>{item.razao_social}</td>
                      <td>{item.voucher}</td>
                      <td>{item.premio.nome}</td>
                    </tr>
                  ))}
                {results
                  .filter(
                    (item) =>
                      item.client_id !== Number(localStorage.getItem("id")),
                  )
                  .map((item, index) => (
                    <tr key={index}>
                      <td style={{ opacity: "0.3" }}>{index + 1}</td>
                      <td>{item.razao_social}</td>
                      <td>{item.voucher}</td>
                      <td>{item.premio.nome}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
          {!!resultsDb.length && !results.length && (
            <p className="prizes-to-withdraw-subtitle">
              Nenhum resultado encontrado para a busca.
            </p>
          )}
          {!resultsDb.length && (
            <p className="prizes-to-withdraw-subtitle">
              Nenhum resultado encontrado para o sorteio selecionado.
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default Results;
